import log from '~/utils/log';

type EnsureShopwareSessionOptions = {
    force?: boolean;
    minIntervalMs?: number;
    reason?: string;
};

const DEFAULT_MIN_INTERVAL_MS = 1_000;

export const useEnsureShopwareSession = () => {
    const isSyncInFlight = useState('shop-session-sync:in-flight', () => false);
    const lastSyncedAt = useState('shop-session-sync:last-synced-at', () => 0);
    const sessionContext = import.meta.client ? useSessionContext() : null;

    const ensureShopwareSession = async (options: EnsureShopwareSessionOptions = {}) => {
        if (import.meta.server) return false;

        const minIntervalMs = options.minIntervalMs ?? DEFAULT_MIN_INTERVAL_MS;
        const now = Date.now();

        if (!options.force && now - lastSyncedAt.value < minIntervalMs) {
            return false;
        }

        if (isSyncInFlight.value) return false;

        isSyncInFlight.value = true;
        try {
            if (!sessionContext) return false;

            await sessionContext.refreshSessionContext();
            lastSyncedAt.value = Date.now();
            return true;
        } catch (error) {
            log.error('[ensure-shopware-session] Failed to refresh session context', {
                reason: options.reason,
                error
            });
            return false;
        } finally {
            isSyncInFlight.value = false;
        }
    };

    return {
        ensureShopwareSession
    };
};
